// extracted by mini-css-extract-plugin
export default {"loggedEmail":"header_loggedEmail__YB8wQ","menu":"header_menu__bsN3F"};